export default {
  forSale: false,
  viewable: true,
  title: 'Áfangi F',
  key: 'afangi-f',
  rect: {
    className: 'bg-dark text-white',
    props: {
      transform: 'translate(1400, 1140) scale(0.7)',
      width: 380,
      height: 130,
    },
  },
  path: {
    d: 'M2166.62 1153.54l-.85-36.92-17.2-10.12-12.69 3.64-5.84-2-2.82-1.61-47 13.1-30.77-5.95-1-11.33-19.45-12.81-40.66 9.41-19.29 5.3-4.5-.8-.64-15.11-18-2.65-13.9-15-45.49 10.69-8.92 7v-12.78l-20.49-11.73-57 14.55s1 15.83.64 16.07-12.29 5.38-12.29 5.38.32 15 0 15-44.68 10.83-44.68 10.83-4.61-4.83-5.14-4.72-36.33 8.57-36.33 8.57l-28-4.34-72.31-11.48-75.46-11.89-50.84-3.7s-26.62 12.06-26.86 12.06 0 4.5 0 4.5l-9.16-.16-1.45-17.92-39.62-1.69-1-18.08-55.77-1.64-18.64 8V1101l-8.68 4.07s1.39 37.82 1 37.82-32.9 6.86-32.9 6.86l-12.64-9.11-4.39.64-1.07-17.25-38.47-6.75-29.62 6.78-15.19-2.09-85.9 18.24v15.43l-13.18 4.18 4.9 66.93 117.56 23.07s63.16 13.34 65.74 13.5 55.6 11.41 55.6 11.41l83.41 16.23 90.11 17.79 53.79 10.82 110.19 22.18 82.15-24.75-.34-33.92 66.21-18.64v-10l34.39-9.32 19.61 4.34 27.64-8.36 65.9 12.53.1 3.87s28.82-16.62 29.25-16.83 28.82-17.46 28.82-17.46l18.75-13.4.54-1.82 24.32-13.39 51.22-23.36z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/sementsreitur/T-F.jpg'),
      width: 5272,
      height: 2962,
    },
    list: [
      {
        lod: 'sudurgata-92',
        d: 'M2959.61 557.67l-2.25-101.78 4.18-57.21-11.68-144.97-8.15-.21-1.07-39.78-86.35.99-4.08-57.21-7.28-.86-3.22-36.43-54-18.21-.21-4.71-81.64-22.93-80.79 25.71.97 119.57-119.74.81-10.77 336.21 179.84.24 179.84.24 106.4.53z',
      },
      {
        lod: 'sudurgata-94',
        d: 'M3416.89 390.43l-25.28-141.32h-17.79l-6.34-38.78-59.98.53-15-94.61-120.11 1.93-3.1-17.89-55.93-39.65-63 42.22-9.59 109.71-100.13 1.15 1.07 39.78 8.15.21 11.68 144.97-4.18 57.21 2.25 101.78 464.78 7.83-17.35-113.79 9.85-61.28z',
      },
      {
        lod: 'sudurgata-96',
        d: 'M3885.64 573.86l-29.89-123.75 14.79-57.54-2.9-11.25 2.57-13.82-36-136.29h-33.85l-4.29-19.15-51.05.51-25.45-97.28-61.93-23.36-75.85-22.07-83.31 25.07-19.93 114.43-111.07.97 6.34 38.78h17.79l25.28 141.32-9.85 61.28 17.35 113.79 461.25 8.36z',
      },
      {
        lod: 'sudurgata-98',
        d: 'M4210.29 577.29l79.28-17.15 44.36 10.72-7.07-31.29-22.5-88.5-18.86-51.51 18.7-52.36 7.18-21.86-17.09-42 14.89-42.8-56.14-151.93-73.77-23.25-87.75 24.91-3.86 9.96-43.39 14.47-10.13 36-14.14.8-17.52 58.5-206.41 2.06 4.29 19.15h33.85l36 136.29-2.57 13.82 2.9 11.25-14.79 57.54 29.89 123.75 60.97 1.76 57.53 1.67h206.15z',
      },
      {
        lod: 'F5',
        d: 'M5098.88 2412.03l-107.44-289.05 38.17-44.19-70.07-184.99-45.81-1.44-63.59-168.65-104.14-3.85 94.29-138.43-42.65-109.5-50.14-.22-55.5-152.14-343.5 2.14-11.57 23.79-546.64 3.21-12.86 32.58-95.57 1.28-7.72 21.86h-15.21l-32.14 103.93-432.65.64-15.43-124.71-68.14.21-6.96-60.43-113.79.97-2.89 23.78-108 .32-1.29-20.25-37.6.33 11.25 236.24-5.79 180.33 14.14 507.85-1.6 74.25h7.07l5.14 161.04-4.18 42.11 8.04 143.35 800.68-7.87 147.42-2.52h153l96-1.5 268.61-3.54h109.61l139.18-2.73 109.28 1.13 266.79-2.25 5.68-7.82 20.14.64 91.5-83.25-36.43-101.36 53.31-51.29z',
      },
      {
        lod: 'F4',
        d: 'M2870.25 2488.93l-5.14-161.04h-7.07l1.6-74.25-14.14-507.85 5.79-180.33-11.25-236.24-315.33 2.78-103.92-56.57-96.22 58.07-1.28 23.14-107.36.22-3-19.72-409.5 2.57-31.82 237 22.5 83.9-35.36 6.75h-278.36l-161.68 31.28-95.35 17.15-18 3.42-21.43 6.65-15 6.21-9.64 5.14-7.72 4.72-8.78 6.86-6.65 7.07-5.57 7.93-151.61 1.5-13.6 52.82-57.43.85-28.18 108.22-47.46.53-136.72 498.43 37.5 45.65-21.21 81.75 116.68 135 776.03-4.4 366.86-3.85 688.28-3 214.4-2.9-8.04-143.35 4.18-42.11z',
      },
      {
        lod: 'F3',
        d: 'M2673.37 556.9l-179.84-.24-3.53 110.2h-621.86l-51.43 27.21-346.5 177.43-301.92 103.71-21-53.57-271.93 80.15 39 139.5 26.78 55.71 18.86 64.29 54.43 114.85 4.07 60 59.79-15.85 87.21-24 51.21-14.58 29.36-11.78 243.22-82.07L1660.5 1236l70.71-27.86 34.61-20.68 27-14.78 61.56-10.29 48.21-4.18h139.82l52.39 2.74 63 8.03 81.65 15.43 28.76 4.98 632.57 2.62 6.76-128.94-10.32-200.57h-27.29V757.39l-16.72-200.25-179.84-.24z',
      },
      {
        lod: 'F2',
        d: 'M3885.64 573.86l-461.25-8.36-464.78-7.83-106.4-.53 16.72 200.25V862.5h27.29l10.32 200.57-6.76 128.94 65.9.28 675.32-4.72 384-3.64 63.22-.22-22.51-107.35 31.08-78-52.08-183.22-8.14-95.78-33.43-142.07-57.53-1.67-60.97-1.76z',
      },
      {
        lod: 'F1',
        d: 'M4401.64 588.64l-67.71-17.78-44.36-10.72-79.28 17.15h-206.15l33.43 142.07 8.14 95.78 52.08 183.22-31.08 78 22.51 107.35 122.57-.42h102.96l155.57 1.28 86.31-172.77-154.99-423.16z',
      },
    ],
  },
}
